import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init() {

    }

    toggle() {
        if(document.documentElement.classList.contains('has-cart-open')) {
            this.call('close', null, 'Cart')
        } else {
            this.call('open', null, 'Cart')
        }
    }

    updateCount(count) {
        let itemsCount = count

        if(itemsCount > 0) {
            document.documentElement.classList.add('has-cart-item')
        } else {
            document.documentElement.classList.remove('has-cart-item')
        }

        this.$('count')[0].innerHTML = itemsCount
    }
}
